// 1. ★ 点滅する青色の円 (Reactコンポーネント) を定義
// (Tailwindの 'sky' (青系) を使います)

import { FC } from "react";

// サイネージは常時稼働なので脈動は数回で止める (無限アニメだと GPU が一度も休めない)。
// 階の切替や「現在地に戻る」でマーカーが描き直されると再び脈動する
const PULSE_DURATION_S = 2;
const PULSE_COUNT = 5;

type Props = {
  className?: string;
};

const CurrentLocationMarker: FC<Props> = ({ className = "" }) => (
  <div className={`${className} relative flex h-5 w-5`}>
    {/* 脈動する外側の円 */}
    <span
      className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"
      style={{
        animationDuration: `${PULSE_DURATION_S}s`,
        animationIterationCount: PULSE_COUNT,
      }}
    ></span>
    {/* 中心の静的な円 */}
    <span className="relative inline-flex rounded-full h-5 w-5 bg-sky-500 border-2 border-white shadow-md"></span>
  </div>
);

export default CurrentLocationMarker;
